import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-ui-no-data-found',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoDataFoundComponent {
  @Input() icon: string | undefined;
  @Input() title: string | undefined;
  @Input() description: string | undefined;
}
